module.exports = __webpack_public_path__ + "img/subbuffer.c4c6e193.png";